import type { FacetCollection } from 'Models/index';

export function getFitmentResponseFacets(
  facets: FacetCollection,
  baseFields: string[],
  extraFields: string[],
  { hideExtraFields, isPartialMode }: { hideExtraFields: boolean; isPartialMode: boolean },
): FacetCollection {
  const fields = [...baseFields, ...extraFields];
  const allBaseFieldsSelected = baseFields.every((field) => {
    const facet = facets.get(field);
    return !facet || facet.selection.length;
  });

  return facets.filter((facet) => {
    // Do not remove any base field.
    if (baseFields.includes(facet.field)) {
      return true;
    }
    // Do not remove any extra field if there is only one base field.
    if (baseFields.length === 1 && extraFields.length && fields.includes(facet.field)) {
      return true;
    }
    // Remove extra fields when hidden, base selection is incomplete, or the field is not configured.
    if (hideExtraFields || !allBaseFieldsSelected || !fields.includes(facet.field)) {
      return false;
    }
    // Keep selected extra fields. Keep unselected extra fields in partial mode or when they have values.
    return !!facet.selection.length || isPartialMode || facet.values.length > 0;
  });
}

export function getRequiredFitmentFields(responseFields: string[], baseFields: string[]): string[] | null {
  const requiredFields = baseFields.filter((field) => responseFields.includes(field));
  return requiredFields.length ? requiredFields : null;
}
